import * as React from 'react';

import type {User} from 'nutshell-core/types';

import {Card} from 'shells/card/card';

import styles from './onboarding-welcome-card.module.css';

type Props = {
    onClose: () => void;
    loggedInUser: User | null | undefined;
};

export class OnboardingWelcomeCard extends React.Component<Props> {
    render() {
        let welcomeText = 'Welcome to Nutshell!';

        if (this.props.loggedInUser) {
            welcomeText = `Welcome, ${this.props.loggedInUser.firstName}`;
        }

        return (
            <Card hasBorder={false}>
                <div className={styles.container}>
                    <div className={styles['img-container']}>
                        <img
                            src='/include/images/dashboard/onboarding-welcome-card_2x.png'
                            className={styles.image}
                        />
                    </div>
                    <h3 className={styles['header-title']}>{welcomeText}</h3>
                    <p className={styles['header-text']}>
                        Nutshell helps your team win deals faster. Explore our interactive demo.
                    </p>
                    <div className={styles['button-wrapper']}>
                        <a href='/demo' className={styles['learn-more-button']}>
                            Start demo
                        </a>
                        <div className={styles['dismiss-link']}>
                            Maybe later,{' '}
                            <a href='#' onClick={this.props.onClose}>
                                dismiss this
                            </a>{' '}
                            for now
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}
